import { gql } from "@apollo/client";
import { DUES_RATE_FRAGMENT } from "../../../../../fragments";

export const GET_DUES_RATES_QUERY = gql`
  query GetDuesRates(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $filters: BackofficeDuesDuesRatesInput!
  ) {
    duesRates(first: $first, last: $last, after: $after, before: $before, filters: $filters) {
      nodes {
        ...DuesRateFragment
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
  ${DUES_RATE_FRAGMENT}
`;

export const GET_DUES_CYCLE_QUERY = gql`
  query GetDuesDuesCycle($year: Int!) {
    duesCycle(year: $year) {
      finalizedSectionCount
      unfinalizedSectionCount
      totalSectionCount
      finalizedSectionNames
      unfinalizedSectionNames
    }
  }
`;
